module.exports = __webpack_public_path__ + "img/timeup.6266ae6d.png";